import React, { useState, useEffect } from 'react';
import TripAdvisorLogo from '../../../images/HomePage/MrSea2025_TripAdvisorIcon.svg';
import '../../styles/home/CompanyTripAdvisorReviewsSection.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faQuoteLeft, faStar } from '@fortawesome/free-solid-svg-icons';

const MAX_COMMENT_LENGTH = 350;
const allReviews = [
  {
    name: 'Gabriela M',
    comment: 'I had the pleasure of spending a day at sea with Mr Sea Boat Rentals. It was an amazing experience, the boat was in excellent condition and fully equipped for a perfect day on the water. Highly recommend this boat service to anyone looking to enjoy the ocean with peace of mind.'
  },
  {
    name: 'juliana',
    comment: 'We had an unforgettable evening aboard the 34-foot Endless Summer with Captain Noe! Cruising through the waters of Miami at night was magical. The city skyline lit up the night sky, creating breathtaking views. Captain Noe was fantastic and knew exactly where to take us for the best sights. Highly recommend for a unique and scenic evening.'
  },
  {
    name: 'Anonymous',
    comment: 'Everything was amazing from start to end. The crew was so professional and friendly. The yacht was super clean and modern. We enjoyed our 4-hour ride and will definitely rebook for a longer period next time. Leo provided fast and high-quality service.'
  },
  {
    name: 'leticiabatistall',
    comment: 'We had a great experience with Mr Sea. Leio was very attentive, helpful and patient. The tour was amazing, and we loved using the float mat. I went with 11 other girls, all of us loved it. We booked the Melissa 44. I recommend them 100%.'
  },
  {
    name: 'neuza c',
    comment: 'Amazing experience! I took the boat out for my birthday with my friends and we had an incredible time. Thank you for the attention and the beautiful places we went to. It made me have the best day!'
  },
  {
    name: 'Jane',
    comment: 'I would definitely recommend Mr.Sea boat rental. Great vibes, nice staff, clean, surround sound speaker on the boat. I will definitely book with these guys again. Jose was my captain and he was awesome. Thank you Mr.Sea for making my daughter\'s graduation boat party amazing!'
  },
  {
    name: 'Iliana C',
    comment: 'Excellent service from start to finish. They kept in communication with me and were very accommodating to our requests. Marco the captain was great!'
  },
  {
    name: 'SILVIA D',
    comment: 'We went on a family boat day. It was a beautiful day and experience. Thank you Leo for your excellent service and all the details. Definitely will repeat this summer! Very recommended.'
  },
  {
    name: 'Tour08776758076',
    comment: 'I went to Miami for my birthday celebration. I had an amazing time. I will definitely recommend Mr Sea Boat rental. Great customer service.'
  },
].map(r => ({
  ...r,
  comment: r.comment.length > MAX_COMMENT_LENGTH ? r.comment.slice(0, MAX_COMMENT_LENGTH) + '...' : r.comment
}));

const useSlidesToShow = () => {
  const [slidesToShow, setSlidesToShow] = useState(window.innerWidth >= 900 ? 3 : 1);
  useEffect(() => {
    const handleResize = () => setSlidesToShow(window.innerWidth >= 900 ? 3 : 1);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return slidesToShow;
};

const CompanyTripAdvisorReviewsSection = () => {
  const slidesToShow = useSlidesToShow();
  const [current, setCurrent] = useState(0);

  const nextReview = () => {
    setCurrent((prev) => (prev + slidesToShow) % allReviews.length);
  };
  const prevReview = () => {
    setCurrent((prev) =>
      (prev - slidesToShow + allReviews.length) % allReviews.length
    );
  };

  const visibleReviews = [];
  for (let i = 0; i < slidesToShow; i++) {
    visibleReviews.push(allReviews[(current + i) % allReviews.length]);
  }

  return (
    <section className="tripadvisor-reviews-section">
      <div className="section-intro">
        <h2 className="section-title-shadow">What Our Guests Are Saying</h2>
      </div>
      <div className="tripadvisor-slider-outer">
        <button
          onClick={prevReview}
          aria-label="Previous review"
          className="tripadvisor-slider-arrow tripadvisor-slider-arrow--left"
        >
          <FontAwesomeIcon icon={faChevronLeft} className="tripadvisor-arrow-shape" />
        </button>
        <div className="tripadvisor-slider-inner">
          {visibleReviews.map((review, idx) => (
            <div key={idx} className="tripadvisor-review-card">
              <a href="https://www.tripadvisor.com.ar/Attraction_Review-g34438-d15060176-Reviews-Mr_Sea_Boat_Rentals-Miami_Florida.html" target="_blank" rel="noopener noreferrer">
                <img src={TripAdvisorLogo} alt="TripAdvisor logo" className="tripadvisor-logo-inside" />
              </a>
              <div className="tripadvisor-review-name">{review.name}</div>
              <div className="tripadvisor-review-comment">
                <FontAwesomeIcon icon={faQuoteLeft} className="tripadvisor-quote" />
                {review.comment}
              </div>
              <div className="tripadvisor-review-rating">
                {[...Array(5)].map((_, i) => (
                  <FontAwesomeIcon icon={faStar} key={i} className="tripadvisor-review-rating-star" />
                ))}
              </div>
            </div>
          ))}
        </div>
        <button
          onClick={nextReview}
          aria-label="Next review"
          className="tripadvisor-slider-arrow tripadvisor-slider-arrow--right"
        >
          <FontAwesomeIcon icon={faChevronRight} className="tripadvisor-arrow-shape" />
        </button>
      </div>
      <div className="tripadvisor-fixed-footer">
        <div className="tripadvisor-footer-content">
          <div className="tripadvisor-footer-left">
            <span>Rated 5 stars by 100+ happy users on TripAdvisor</span>
            <a href="https://www.tripadvisor.com.ar/Attraction_Review-g34438-d15060176-Reviews-Mr_Sea_Boat_Rentals-Miami_Florida.html" target="_blank" rel="noopener noreferrer">
              <img src={TripAdvisorLogo} alt="TripAdvisor logo small" className="tripadvisor-footer-logo" />
            </a>
          </div>
          <div className="tripadvisor-footer-right">
         
            <div className="tripadvisor-footer-address">401 Biscayne Blvd, Miami, FL 33132</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyTripAdvisorReviewsSection;